export default __webpack_public_path__ + "static/media/thrivingPetsPlusLogo-white.77134616.svg";